import { message } from "antd";
import {
  addFolder, deleteFolder, updateFolder, folderList,
  deleteTemplateById, fetchTemplateData, moveTemplate, fetchPreview, fetchRoute
} from "../../../../services/dataReport/template";

const initState = {
};
export default {
  namespace: "dataReportTemplate",

  state: initState,

  effects: {
    *getHealthCodeFlag({ payload }, { call }) {
      try {
        const { showHealthCodeFlag } = yield call(fetchRoute, payload);
        return Promise.resolve(showHealthCodeFlag);
      } catch (error) {
        return Promise.reject();
      }
    },
    // 获取模版
    *fetchTemplateData({ payload }, { call}) {
      try {
        const data = yield call(fetchTemplateData, payload);
        return Promise.resolve(data);
      } catch (error) {
        console.log(error)
        return Promise.reject();
      }
    },
    // 获取文件夹
    *fetchFolderList({ payload }, { call}) {
      try {
        const data = yield call(folderList, payload);
        return Promise.resolve(data);
      } catch (error) {
        console.log(error)
        return Promise.reject();
      }
    },
    // 模版/文件夹操作
    *fetchRequest({ payload }, { call }) {
      try {
        const {requestResponse, fetchType, ...params} = payload;

        const fetchMap = {
          "addFolder": { request: addFolder, tip: "新增成功" }, // 新增文件夹
          "deleteFolder": { request: deleteFolder, tip: "删除成功" }, // 删除文件夹
          "updateFolder": { request: updateFolder, tip: "重命名成功" }, // 修改文件夹
          "deleteTemplate": { request: deleteTemplateById, tip: "删除成功" },
          "moveTemplate": { request: moveTemplate, tip: "移动成功" },
        };

        const response = yield call(fetchMap[fetchType].request, params);

        if(!requestResponse) {
          message.success(`${fetchMap[fetchType].tip}`);
          return Promise.resolve(response);
        }

        // requestResponse为true是，需要接口有返回值才表示操作成功
        if(response) {
          message.success(`${fetchMap[fetchType].tip}`);
          return Promise.resolve(response);
        }

        return Promise.reject();

      } catch (error) {
        return Promise.reject();
      }
    },
    // 预览
    *fetchPreview({ payload }, { call}) {
      try {
        const data = yield call(fetchPreview, payload);
        return Promise.resolve(data);
      } catch (error) {
        console.log(error)
        return Promise.reject();
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    reset() {
      return { ...initState };
    }
  }
};
